import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services';
import { NewsletterItemFileService } from './newsletter-item-file.service';
import { NewsletterItemFileInitialState, NewsletterItemFileLoad } from './newsletter-item-file.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface NewsletterItemFileStateModel {
  newsletterFileText: string;
  loaded: boolean;
}

const initialState: NewsletterItemFileStateModel = {
  newsletterFileText: null,
  loaded: false,
};

@State<NewsletterItemFileStateModel>({
  name: 'newsletterItemFile',
  defaults: initialState,
})
@Injectable()
export class NewsletterItemFileState {
  @Selector()
  static getState(state: NewsletterItemFileStateModel): NewsletterItemFileStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: NewsletterItemFileStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private newsletterItemFileService: NewsletterItemFileService,
    private notificationService: NotificationService,
  ) {}

  @Action(NewsletterItemFileLoad)
  getNewsletterItemFile(
    ctx: StateContext<NewsletterItemFileStateModel>,
    { payload }: NewsletterItemFileLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.newsletterItemFileService.getNewsletterItemFile(payload).pipe(
      map((newsletterFileText: string) => {
        ctx.patchState({ newsletterFileText, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(NewsletterItemFileInitialState)
  setInitialState(ctx: StateContext<NewsletterItemFileStateModel>): void {
    ctx.setState(initialState);
  }
}
